export default __webpack_public_path__ + "static/media/98-07_header_invoice.507b6f4f.png";